import axios from '@/service/request';
import apiConfig from '../apiConfig';

const movieBaseUrl = apiConfig.movieApiDomain;

const shortBaseUrl = apiConfig.shortApiDomain;

// A币充值
// 支付类别
export const getPayCategory = params => axios.get('/pay/getPayCategory', { params: { ...params } });

// 支付通道
export const getChannel = params => axios.post('/pay/getChannel', params);

// 支付提交
export const addPay = params => axios.post('/pay/addPay', params);

// 会员充值
// 支付类别
export const vipPayCategory = params => axios.get('/pay/vipPayCategory', { params: { ...params } });

// 支付通道
export const vipChannel = params => axios.post('/pay/vipChannel', params);

// 支付提交
export const vipPay = params => axios.post('/pay/vipPay', params);

// 观看历史
export const getWatchHistory = params => axios.get(`${movieBaseUrl}/video/getWatchHistory`, { params: { ...params } });

// 任务列表
export const taskList = params => axios.get('/task/list', { params: { ...params } });

// 添加-修改取款密码
export const withdrawPasd = params => axios.post('/member/payAdd', params);

// 关注列表
export const getFollows = params => axios.get('/member/getFocus', { params: { ...params } });

// 粉丝列表
export const getFans = params => axios.get('/member/getFollowed', { params: { ...params } });

// 修改登录密码
export const modifyLoginPassword = params => axios.post('/member/upPassword', params);

// 修改资料
export const userInfoEdit = params => axios.post('/member/upMember', params);

// 我的钱包
export const getWallet = params => axios.get('/member/getWallet', { params: { ...params } });

// 账单
export const getBillList = params => axios.get('/amount/getList', { params: { ...params } });

// 签到列表
export const getSignList = params => axios.get('/task/getSignList', { params: { ...params } });

// 签到
export const doSign = params => axios.post('/task/addSign', params);

// vip中心列表
export const getVipInfo = params => axios.get('/vip/info', { params: { ...params } });

// 自己关注的列表
export const getFocus = params => axios.get('/member/getFocus', { params: { ...params } });

//  作品管理-数量统计
export const getMyWorkCount = () => axios.get('/member/getMyWork');

//  推广代理-统计
export const getPromotion = () => axios.get('/member/getPromotion');

//  推广充值-收益明细
export const getPromotionList = () => axios.get('/member/getPromotionList');

//  我的邀请历史记录
export const getInvite = params => axios.get('/member/getInvite', { params: { ...params } });

//  我的购买-短视频
export const getMyBuyShort = params => axios.get(`${shortBaseUrl}/shortVideo/getMyPay`, { params: { ...params } });

//  我的购买-长视频
export const getMyBuyLong = params => axios.get('video/getMyPay', { params: { ...params } });

/**
 * 粉丝团
 * */

// 查看粉丝团信息
export const getFansGroupInfo = params => axios.get(`${shortBaseUrl}/shortGroup/author_group`, { params: { ...params } });

// 加入粉丝团
export const joinFansGroup = params => axios.post(`${shortBaseUrl}/shortGroup/addGroup`, params);

// 粉丝排行榜
export const getFansGroupRankings = params => axios.get(`${shortBaseUrl}/shortGroup/groupRankings`, { params: { ...params } });

// 发布留言
export const fansGroupPostComment = params => axios.post(`${shortBaseUrl}/shortGroup/addMessage`, params);

// 回复留言
export const fansGroupReplyComment = params => axios.post(`${shortBaseUrl}/shortGroup/replyMessage`, params);

// 留言点赞/取消点赞
export const fansGroupDoLikeNoLike = params => axios.get(`${shortBaseUrl}/shortGroup/likeMessage`, { params: { ...params } });

// 留言板列表
export const getFansGroupComments = params => axios.get(`${shortBaseUrl}/shortGroup/getMessage`, { params: { ...params } });

// 留言板回复列表
export const getFansGroupReply = params => axios.get(`${shortBaseUrl}/shortGroup/getMessageSub`, { params: { ...params } });

//  收支明细
export const getIncomeCostDetails = params => axios.get('/amount/getList', { params: { ...params } });

//  作品收益
export const getWorkIncomeDetails = params => axios.get('/amount/getWorkList', { params: { ...params } });

//  用户消息
export const getUserMsg = params => axios.get('/member/getUserMsg', { params: { ...params } });

//  用户消息详情
export const getUserMsgDetail = params => axios.get('/member/getMsgDetail', { params: { ...params } });

//  用户消息中关于相应视频的收藏喜欢
export const getVideoUserList = params => axios.get('/member/getVideoUserList', { params: { ...params } });

//  会员免费看金币电影视频
export const postAddVipVideo = params => axios.post('/member/addVipVideo', params);

//  短视频扣费
export const getShortDeductMoney = params => axios.get(`${shortBaseUrl}/shortVideo/addVideoMoney`, { params: { ...params } });

//  影片收费
export const getVideoDeductMoney = params => axios.get(`${movieBaseUrl}/video/addVideoMoney`, { params: { ...params } });

//  游客用户手机号/登录密码
export const postTouristMember = params => axios.post('/member/touristMember', params);

//  查看是否还有剩余次数
export const getFreeWatchCount = (params) => axios.get('/member/getFreeWatchCount', { params: params });
